import { render, staticRenderFns } from "./performance-brand-overview.vue?vue&type=template&id=38614d74&scoped=true"
import script from "./performance-brand-overview.vue?vue&type=script&lang=js"
export * from "./performance-brand-overview.vue?vue&type=script&lang=js"
import style0 from "./performance-brand-overview.vue?vue&type=style&index=0&id=38614d74&prod&lang=scss"
import style1 from "./performance-brand-overview.vue?vue&type=style&index=1&id=38614d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38614d74",
  null
  
)

export default component.exports